import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useUpdateQueryParams from 'flow-doctor-lib/hooks/useUpdateQueryParams';
import usageTracker from 'flow-doctor-lib/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChooseObjectSection = ({
  objectId,
  objectTypeId,
  CrmObjectSelectComponent
}) => {
  const updateQueryParams = useUpdateQueryParams();
  const onObjectIdSelect = newObjectId => {
    usageTracker.track('pageAction', {
      actionType: 'CHOOSE_NON_ENROLLMENT_OBJECT',
      objectTypeId
    });
    updateQueryParams({
      objectId: newObjectId
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.chooseTrigger.chooseAnObject"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(CrmObjectSelectComponent, {
      onChange: onObjectIdSelect,
      objectTypeId: objectTypeId,
      selectedObjectId: objectId
    })]
  });
};
export default ChooseObjectSection;